import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const probateReferralsApi = createApi({
  reducerPath: "probateReferralsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["ProbateReferral"],
  endpoints: (build) => ({
    getAllProbateReferrals: build.query({
      query: ({ category, type, limit = 1000 } = {}) => ({
        url: "/probate/referrals",
        method: "GET",
        params: { category, type, limit },
      }),
      providesTags: ["ProbateReferral"],
    }),
    createProbateReferral: build.mutation({
      query: (data) => ({ url: "/probate/referrals", method: "POST", body: data }),
      invalidatesTags: ["ProbateReferral"],
    }),
    updateProbateReferral: build.mutation({
      query: ({ id, ...data }) => ({ url: `/probate/referrals/${id}`, method: "PUT", body: data }),
      invalidatesTags: ["ProbateReferral"],
    }),
    deleteProbateReferral: build.mutation({
      query: (id) => ({ url: `/probate/referrals/${id}`, method: "DELETE" }),
      invalidatesTags: ["ProbateReferral"],
    }),
  }),
});

export const {
  useGetAllProbateReferralsQuery,
  useCreateProbateReferralMutation,
  useUpdateProbateReferralMutation,
  useDeleteProbateReferralMutation,
} = probateReferralsApi;
